import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import {
  PopupSaveAndCancel,
  PropertyType,
  ServiceType,
} from '@my-models/api-model';
import { Validation } from '@my-providers/confirm-password.validator';
import { CommonApiService } from '@my-services/common-api.service';
import { Constants } from '@my-util/constants';
import Utility from '@my-util/utility';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-post-property-pop',
  templateUrl: './post-property-pop.component.html',
  styleUrls: ['./post-property-pop.component.css'],
})
export class PostPropertyPopComponent implements OnInit {
  @Input() brokerIds: number = 82;
  @Output() ClosePopUp: EventEmitter<any> = new EventEmitter<any>();
  pageObjet: PopupSaveAndCancel = {
    Save: false,
    data: null,
  };
  modalRef?: BsModalRef;
  cityListArr = [];
  propertyType = Utility.propertyType;
  private _subscriptions: Subscription[] = [];
  selectedPropertyTypeObj!: any;
  constructor(
    private fb: FormBuilder,
    private _commonApiService: CommonApiService,
    private router: Router
  ) {}

  postPropertyForm = this.fb.group({
    city: [null, [Validators.required]],
    propertyType: ['', [Validators.required]],
    serviceType: ['', [Validators.required]],
  });

  ngOnInit() {
    setTimeout(() => {
      this.getAllCity();
      this.propertyType.forEach((element) => (element.isSelected = false));
    }, 0);
  }

  closeModal(isSave: boolean = false) {
    this.ClosePopUp.emit(this.pageObjet);
  }
  getAllCity() {
    this._subscriptions.push(
      this._commonApiService.GET('/PostPropertySale/GetAllCity').subscribe({
        next: (response: any) => {
          this.cityListArr = response.data;
        },
        error: (error: any) => {
          console.log(error);
        },
      })
    );
  }
  onChangePropertyType(obj: PropertyType) {
    this.selectedPropertyTypeObj = obj?.serviceType;
    this.propertyType.forEach((element: PropertyType) => {
      element.isSelected = false;
    });
    this.selectedPropertyTypeObj.forEach((element: ServiceType) => {
      element.isSelected = false;
    });
    this.postPropertyForm.patchValue({
      propertyType: obj.name ?? null,
      serviceType: null,
    });
    obj.isSelected = true;
  }
  onChangeServiceType(obj: ServiceType) {
    this.selectedPropertyTypeObj.forEach((element: ServiceType) => {
      element.isSelected = false;
    });
    this.postPropertyForm.patchValue({
      serviceType: obj.name ?? null,
    });
    obj.isSelected = true;
  }

  onSave() {
    let fval: any = this.postPropertyForm.value;
    const URL = `${Constants.HOME_ROUTE}/${Constants.POST_PROPERTY}`;
    const routes: any = {
      Residential: {
        Rent: `${URL}/${Constants.RESIDENTIAL}/${Constants.RENT}`,
        Sale: `${URL}/${Constants.RESIDENTIAL}/${Constants.SALE}`,
        'PG/Hostel': `${URL}/${Constants.RESIDENTIAL}/${Constants.PG_HOSTEL}`,
      },
      Commercial: {
        Rent: `${URL}/${Constants.COMMERCIAL}/${Constants.RENT}`,
        Sale: `${URL}/${Constants.COMMERCIAL}/${Constants.SALE}`,
      },
      'Land/Plot': {
        Rent: `${URL}/${Constants.LAND_PLOT}/${Constants.RENT}`,
        Sale: `${URL}/${Constants.LAND_PLOT}/${Constants.SALE}`,
      },
    };
    const path: any = routes[fval.propertyType]?.[fval.serviceType];
    if (path) {
      this.router.navigate([path], {
        queryParams: {
          id: this.brokerIds,
          ct: fval?.city,
          pt: fval?.propertyType,
          st: fval?.serviceType,
        },
      });
    } else {
      console.error('Invalid inventory type or service type');
    }
    this.closeModal();
  }
}
